import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';

import { Subject } from 'rxjs/Rx';
declare var $: any;
import * as _ from 'lodash';
import { AlertComponent } from '../../alert/alert.component';
import { GroupMasterService } from 'src/app/services/group-master.service';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { environment } from 'src/environments/environment';
import { LoaderService } from 'src/app/services/loader.service';
@Component({
  selector: 'app-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.css']
})
export class TagComponent implements OnInit {

  public environmentSettings: any;
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  // The trigger needed to re-render the table
  dtTrigger: Subject<any> = new Subject();
  groupMasterForm: FormGroup;
  groups: any[];
  groupId: string;
  error: any = { isError: false, errorMessage: '' };

  constructor(private groupMasterService: GroupMasterService,
    private alert: AlertComponent,
    private commonFunction: CommonFunction,
    private loaderService: LoaderService) { }

  ngOnDestroy(): void {
    // Re-enable loader when navigating away from this component
    this.loaderService.enable();
  }

  ngOnInit() {

    this.environmentSettings = environment;

    this.commonFunction.validateURL('Tag', '');
    this.initialiseJqueryEvents();

    // this.commonFunction.removeDataTableSaveStateKey("groupTable");

    this.getGroupsList();

    this.dtOptions = {
      destroy: true,
      scrollY: "430px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }],
      dom: 'lBfrtip',//'Bfrtip',
      // Configure the buttons
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Tag List',
          title: 'Tag List',
          extend: 'excel',
          exportOptions: {
            columns: [0],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          }

        }
      ]
    };

    this.groupMasterForm = new FormGroup({
      GroupName: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z0-9][a-zA-Z0-9\-\_\/ ]*[a-zA-Z]+[a-zA-Z0-9\-\_\/ ]*$")
      ]),

    });

  }

  getGroupsList() {
    this.groups = [];
    this.groupMasterService.getGroupList()
      .subscribe((groupList:any) => {
        if (groupList.status == 0) {
          this.groups = groupList.groupList;
          this.dtTrigger.next();
        }
      })
  }

  // showAddPopUp() {
  //   $("#myModalLabel").html('<i class="fa fa-plus"></i>Add Tag');
  //   $('#btnsaveGroup').show();
  //   $('#btnupdateGroup').hide();
  //   this.groupMasterForm.reset();
  //   this.groupId = "";
  //   this.groupMasterForm.setValue({ GroupName: "" });
  //   this.error = { isError: false, errorMessage: '' }
  // }

  // addGroup() {
    
  //   if (this.groupMasterForm.status == "VALID") {
  //     var loginUsers = JSON.parse(localStorage.getItem("user"));
  //     var newGroup = {
  //       GroupName: this.groupMasterForm.controls.GroupName.value,
  //       CreatedBy: loginUsers._id
  //     }

  //     this.groupMasterService.addGroup(newGroup)
  //       .subscribe(group => {
  //         if (group.status == 0) {
  //           // this.groupMasterForm.reset();
  //           $('#groupDialog123').modal('disclose');
  //           // this.alert.success("Tag created successfully");

  //         } else {
  //           $('#groupDialog').modal('toggle');
  //           // this.alert.error(group.message);
  //           this.alert.error(JSON.stringify(group.message));
  //         }

  //         if (this.dtElement.dtInstance != undefined) {
  //           this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
  //             dtInstance.destroy();
  //           });
  //         }
  //         this.getGroupsList();

  //       });
  //   }
  //   else {
  //     console.log('Invalid form submit.')
  //     return false;
  //   }
  // }

  editGroup() {

    if (this.groupMasterForm.status == "VALID") {
      var loginUsers = JSON.parse(localStorage.getItem("user"));
      var updatedGroup = {
        GroupId: this.groupId,
        GroupName: this.groupMasterForm.controls.GroupName.value,
        ModifiedBy: loginUsers._id
      }
      this.groupMasterService.updateGroup(updatedGroup)
        .subscribe((group:any) => {
          if (group.status == 0) {
            $('#groupDialog').modal('toggle');
            this.alert.success("Tag updated successfully");
            this.groupMasterForm.reset();

          } else {
            $('#groupDialog').modal('toggle');
            // this.alert.error(group.message);
            // if (group.err_fields != undefined && group.err_fields != "") {
            //   this.alert.error(group.message);
            // }
            // else {
            //   this.alert.error(group.message);
            // }

            this.alert.error(group.message);

          }
          if (this.dtElement.dtInstance != undefined) {
            this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
              dtInstance.destroy();
            });
          }
          this.getGroupsList();
        });
    }
    else {
      return false;
    }
  }
  add(){
    $('#groupDialog').modal('toggle');
  }
  deleteConfirmation(groupId) {
    this.groupId = groupId
    $('#confirmation').modal('toggle');
  }
addgroup(){
  if (this.groupMasterForm.status == "VALID") {
  var loginUsers = JSON.parse(localStorage.getItem("user"));
  var newGroup = {
    GroupName: this.groupMasterForm.controls.GroupName.value,
    CreatedBy: loginUsers._id
  }
  this.groupMasterService.addGroup(newGroup).subscribe((group:any) => {
    if (group.status == 0) {
      $('#groupDialog').modal('toggle');
      this.alert.success("Tag created successfully");
      this.groupMasterForm.reset();
    }
    else {
      $('#groupDialog').modal('toggle');
      this.alert.error(JSON.stringify(group.message));
    }

    if (this.dtElement.dtInstance != undefined) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
      });
    }
    this.getGroupsList();

  });
}
else {
  console.log('Invalid form submit.')
  return false;
}
}
  deleteGroup() {
    this.groupMasterService.deleteGroup(this.groupId).subscribe((data:any) => {
      if (data.status == 0) {
        $('#confirmation').modal('toggle');
        this.alert.success("Tag deleted successfully");
      }
      else {
        $('#confirmation').modal('toggle');
        this.alert.error(data.message);
      }

      if (this.dtElement.dtInstance != undefined) {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
        });
      }
      this.getGroupsList();

    });
  }

  loadGroupToEdit(groupId) {
    this.loaderService.disable();
    this.groupMasterService.getGroupById(groupId)
      .subscribe((group:any) => {
        if (group.status == 0) {
          $('#groupDialog').modal('toggle') //
          this.groupId = group.groupData[0]._id;
          this.groupMasterForm.controls.GroupName.setValue(group.groupData[0].GroupName);
          $("#myModalLabel").html('<i class="fa fa-pencil"></i> Update Tag');
          $('#btnsaveGroup').hide();
          $('#btnupdateGroup').show();
          this.error = { isError: false, errorMessage: '' }
        }
      });
  }

  keyDownEnterFunction(ev) {
    if (ev.keyCode == 13) {
      if (this.groupMasterForm.status == "VALID") {
        var loginUsers = JSON.parse(localStorage.getItem("user"));
        var newGroup = {
          GroupName: this.groupMasterForm.controls.GroupName.value,
          CreatedBy: loginUsers._id
        }

        this.groupMasterService.addGroup(newGroup)
          .subscribe(group => {
            if (group.status == 0) {
              $('#groupDialog').modal('toggle');
              this.alert.success("Tag created successfully");
              this.groupMasterForm.reset();

            } else {
              $('#groupDialog').modal('toggle');
              this.alert.error(group.message);
            }

            if (this.dtElement.dtInstance != undefined) {
              this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                dtInstance.destroy();
              });
            }
            this.getGroupsList();

          });

      } else {
        console.log('Invalid form submit.')
        return false;
      }
    }
  }

  initialiseJqueryEvents() {

    $('.modal-dialog').draggable({
      handle: ".modal-header"
    });

    $('#groupDialog').on('shown.bs.modal', function (e) {
      $('#groupName').focus();
    });

  }

}
